import React from 'react';
import { Box, Typography } from '@mui/material';

interface PhotoEmptyStateProps {
  caption: string;
}

function PhotoEmptyState({ caption }: PhotoEmptyStateProps) {
  return (
    <Box
      sx={{
        textAlign: 'left',
        p: 4,
        background: '#fff',
        borderRadius: '8px',
      }}
    >
      <Typography variant="subtitle1">
        No photos yet
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {caption}
      </Typography>
    </Box>
  );
}

export default PhotoEmptyState;
